import React, { useState } from 'react';
import styled from 'styled-components';

interface ImagePopupOnHoverProps {
    src: string;
    alt?: string;
    width?: number;  // Optional: define the size of the small image
    height?: number; // Optional: define the size of the small image
}

const ExpandingImage: React.FC<ImagePopupOnHoverProps> = ({ src, alt, width = 200, height = 200 }) => {
    const [showPopup, setShowPopup] = useState(false);
    const [popupPosition, setPopupPosition] = useState<{ top: number; left: number }>({ top: 0, left: 0 });

    const handleMouseEnter = (event: React.MouseEvent<HTMLImageElement, MouseEvent>) => {
        const rect = event.currentTarget.getBoundingClientRect();
        setPopupPosition({
            top: rect.top + window.scrollY, // Position the popup based on the image's position on the page
            left: rect.left + window.scrollX + rect.width + 10, // Adjust to show the popup to the right
        });
        setShowPopup(true);
    };

    const handleMouseLeave = () => {
        setShowPopup(false);
    };

    return (
        <>
            <ImageContainer>
                <SmallImage
                    src={src}
                    alt={alt}
                    width={width}
                    height={height}
                    onMouseEnter={handleMouseEnter}
                    onMouseLeave={handleMouseLeave}
                />
            </ImageContainer>
            {showPopup && (
                <Popup style={{ top: popupPosition.top, left: popupPosition.left }}>
                    <LargeImage src={src} alt={alt} />
                </Popup>
            )}
        </>
    );
};

export default ExpandingImage;

const ImageContainer = styled.div`
    position: relative;
    display: inline-block;
`;

const SmallImage = styled.img`
    display: block;
    width: 100%;
    height: 100%;
    border-radius: 50%;
    object-fit: cover;
`;

const Popup = styled.div`
    position: fixed;
    z-index: 1000;  /* Ensure it's above other content */
    border: 1px solid #ccc;
    background-color: white;
    padding: 10px;
    box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.1);
`;

const LargeImage = styled.img`
    width: 400px; /* Size of the enlarged image */
    height: auto;
    object-fit: contain;
`;
